import type { SectionItem } from '@/types/components/section-item'

export const RESIDENTIAL_SECTION_ITEMS: SectionItem[] = [
	{
		id: 'residential-1',
		viewbox: {
			width: 405,
			height: 405
		},
		image: {
			url: '/images/fiber.webp',
			alt: 'Maverix Fiber-fast internet'
		},
		lines: [
			{
				rotation: -15,
				length: 150,
				direction: 'counter-clockwise'
			}
		],
		circles: []
	},
	{
		id: 'residential-2',
		viewbox: {
			width: 405,
			height: 405
		},
		image: {
			url: '/images/guy-looking-at-computer.webp',
			alt: 'Maverix Fiber-fast internet'
		},
		lines: [],
		circles: [
			{
				cx: 327,
				cy: 76,
				r: 61,
				fill: '#01629E'
			},
			{
				cx: 377.5,
				cy: 88,
				r: 21,
				fill: '#FF8A02'
			}
		]
	}
]
